import React from 'react';
import {taxMoney} from './taxExport';

export default function TaxOrderTable({rows, pagination, filters, onChange}) {
  function sortable(label, key) {
    const selected = filters.sort === key;
    return <th scope="col" aria-sort={selected ?
      (filters.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <button type="button" className="tax-center__sort" onClick={() => onChange({
        sort: key, dir: selected && filters.dir === 'desc' ? 'asc' : 'desc', page: 1,
      })}>{label} {selected ? (filters.dir === 'asc' ? '↑' : '↓') : '↕'}</button>
    </th>;
  }
  return <div className="tax-center__panel">
    <h2>Order details</h2>
    <p className="tax-center__muted">Dates and date filters use UTC. Tax amounts are estimates.</p>
    {!rows.length ? <p>No paid orders to display for these filters.</p> :
      <div className="tax-center__table-scroll" role="region" aria-label="Order tax details"
        tabIndex={0}>
        <table><thead><tr>{sortable('Order date', 'date')}<th scope="col">Product</th>
          <th scope="col">Buyer state</th>{sortable('Amount', 'amount')}
          {sortable('Sales tax', 'salesTax')}<th scope="col">Federal tax</th>
          {sortable('Total tax', 'totalTax')}<th scope="col">Order</th></tr></thead>
        <tbody>{rows.map(row => <tr key={row.orderUuid}>
          <td>{new Date(row.createdAt).toLocaleDateString('en-US', {timeZone: 'UTC'})}</td>
          <td>{row.productName || 'Removed product'}</td><td>{row.buyerState || 'Unknown'}</td>
          <td>{taxMoney(row.orderAmount)}</td><td>{taxMoney(row.salesTax)}
            <small>{(row.salesTaxRate * 100).toFixed(2)}%</small></td>
          <td>{taxMoney(row.federalTax)}<small>
            {(row.federalTaxRate * 100).toFixed(1)}%</small></td>
          <td>{taxMoney(row.totalTax)}</td><td><a
            href={`/account/orders/${encodeURIComponent(row.orderUuid)}`}>View order</a></td>
        </tr>)}</tbody></table>
      </div>}
    <div className="tax-center__pagination">
      <label>Orders per page<select value={filters.pageSize} onChange={event =>
        onChange({pageSize: Number(event.target.value), page: 1})}>
        {[25, 50, 100, 200].map(size => <option key={size}>{size}</option>)}
      </select></label>
      <span>Page {pagination.page} of {pagination.totalPages} · {pagination.totalRows} orders</span>
      <div className="tax-center__actions">
        <button type="button" className="button small secondary" disabled={pagination.page <= 1}
          onClick={() => onChange({page: pagination.page - 1})}>Previous</button>
        <button type="button" className="button small secondary"
          disabled={pagination.page >= pagination.totalPages}
          onClick={() => onChange({page: pagination.page + 1})}>Next</button>
      </div>
    </div>
  </div>;
}
